"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get FloatingInput if you don\'t pass any properties. ' +
    'It has a nice elevation when focused.';
var code = "import React from 'react';\nimport { FloatingInput } from 'jsc-react-ui';\n\nconst Example = () => <FloatingInput />;";
exports.RawExampleFloatingInput = function (props) { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.FloatingInput, null))); };
exports.RawExampleFloatingInput.displayName = 'RawExampleFloatingInput';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFloatingInputPage/RawExampleFloatingInput.tsx
// module id = 674
// module chunks = 0